// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"525":"unslug","743":"lang-[request]"}[chunkId] + "." + {"525":"8f60d655","743":"db6148fe"}[chunkId] + ".js";
};